import React from 'react';

/**
 * Career Champ two-line wordmark.
 * variant="dark"  — dark navy + blue (for white/light backgrounds)
 * variant="light" — white + light blue (for dark/gradient backgrounds)
 */
const CareerChampWordmark = ({ variant = 'dark', className = '' }) => {
    const careerColor = variant === 'light' ? '#FFFFFF' : '#0F1829';
    const champColor  = variant === 'light' ? '#8B9EFF' : '#4F5CF5';

    return (
        <div
            className={`flex flex-col leading-none select-none ${className}`}
            style={{ fontFamily: "'Barlow Condensed', 'Arial Narrow', sans-serif" }}
        >
            <span style={{ fontSize: '1em', fontWeight: 800, fontStyle: 'italic', color: careerColor, lineHeight: 1 }}>
                CAREER
            </span>
            <span style={{ fontSize: '0.93em', fontWeight: 200, fontStyle: 'italic', color: champColor, lineHeight: 1.05 }}>
                CHAMP
            </span>
        </div>
    );
};

export default CareerChampWordmark;
